import React from 'react';
import './App.css';
import "./Container/Container"
import Container from './Container/Container';
import Title from "./Title"


function App() {
  return (
    <div className="App">
      <Title />
      <Container />
    </div>
  );
}

export default App;
